import { jsx as _jsx } from "react/jsx-runtime";
import usePageStore from '../Page/pageStore';
import { useLocation } from 'react-router-dom';
import { getPath } from '../Router/Router';
import { API, solutionsPath } from '../globalUtils';
import useDataStore from '../Data/dataStore';
import RandomShaderAnimation from './RandomShaderAnimation';
const SolutionsBackgroundSwitch = () => {
    const data = useDataStore((state) => state.data);
    const { activePage, shownPage, activeSection } = usePageStore();
    const animations = (data[API.setup]?.bespoke_animations ?? []).map((item) => item.animation_item);
    const urlPath = getPath(useLocation().pathname);
    const allowed = (activePage === solutionsPath || shownPage === solutionsPath) &&
        data[solutionsPath] &&
        data[API.setup]?.bespoke_animations;
    const dataAnimationState = data[urlPath]?.page_sections?.[activeSection]?.solutions_header
        ?.logo_background_anim;
    const animationState = dataAnimationState;
    return allowed ? (_jsx("div", { className: "solutions-background-animation", children: _jsx("div", { className: "solutions-background-animation-wrapper", children: _jsx(RandomShaderAnimation, { animations: animations, animationState: animationState, close: activePage !== solutionsPath && shownPage === solutionsPath }) }) })) : null;
};
export default SolutionsBackgroundSwitch;
